function isSafariMixin() {
  return Boolean(navigator.vendor.match(/[Aa]+pple/g));
}

export default isSafariMixin;
